
























import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class PkLiveBox extends Vue {
  videoContent:string='';
  fbContent:string='';
  contactContent:string='';
  MapInfo:string = '';
  CatName:string = '';
  currentPage: number = 1; // 当前页
  pageSize: number = 2; // 每页显示条目个数
  ContentList:any[]=[];
  AboutName:string='';
  AboutContent:string='';
  ImagePath:string='';
  getFbContent () {
    this.$Api.cms.getContentByDevice({ Key: 'Facebook', IsMobile: false }).then(result => {
      this.fbContent = result.CMS.Body;
    });
  }
 getVideoContent () {
    this.$Api.cms.getContentByDevice({ Key: 'Youtube', IsMobile: false }).then(result => {
      this.videoContent = result.CMS.Body;
    });
  }
  get currentlang () {
    return this.$i18n.locale;
  }
  getContactBox () {
    this.$Api.cms.getContentByDevice({ Key: 'contactus', IsMobile: false }).then(result => {
      this.contactContent = result.CMS;
      this.getCategoryByDevice(result.CMS.CatId);
    });
  }
  getAboutus () {
    this.$Api.cms.getCategoryByDevice({ Key: 'About', IsMobile: false }).then(async (result) => {
      this.AboutContent = result.Content;
      this.AboutName = result.Name;
      this.ImagePath = result.ImagePath;
      this.$store.dispatch('setHkLiveBox', this.AboutName);
    }).catch((error) => {
      this.$message({
        message: error,
        type: 'error'
      });
    });
  }
    // 根据设备类型获取CMSCategory信息
  getCategoryByDevice (cateId) {
    this.$Api.cms.getCategoryByDevice({ CatId: cateId, IsMobile: false }).then(async (result) => {
      this.MapInfo = result.Content;
      this.CatName = result.Name;
    }).catch((error) => {
      this.$message({
        message: error,
        type: 'error'
      });
    });
  }
  // getContentsList() {
  //     var params = {
  //       Key: 'HomeRelated',
  //       Page: this.currentPage,
  //       PageSize: this.pageSize
  //     };
  //     this.$Api.cms.getContentsByCatKeyEx(params).then((result) => {
  //       result.Data.forEach((item) => {
  //           if (item.Key === 'Youtube') {
  //               this.videoContent = item.Body;
  //           }
  //           if (item.Key === 'Facebook') {
  //               this.fbContent = item.Body;
  //           }
  //       });
  //     });
  //   }
  created () {
    this.getFbContent();
    this.getVideoContent();
    this.getContactBox();
    this.getAboutus();
  }
  get lang () {
    return this.$Storage.get('locale');
  }
}
